import { RootState } from 'app/store';

export const selectPopoutContainer = (state: RootState) =>
  state.popout.container;

export const selectPopoutVisible = (state: RootState) =>
  state.popout.popoutVisible;

export const selectPopoutTheme = (state: RootState) => state.popout.theme;

export const selectTransitioningState = (state: RootState) =>
  state.popout.transitioning;
